const template = [
  {
    path: '/template',
    component: () => import('@/mobile/page/template'),
    children: [
      {
        path: '/template/button',
        component: () => import('@/mobile/page/template/Button'),
        meta: {
          name: 'Button',
        },
      },
      {
        path: '/template/layout',
        component: () => import('@/mobile/page/template/Layout'),
        meta: {
          name: 'Layout',
        },
      },
      {
        path: '/template/input',
        component: () => import('@/mobile/page/template/Input'),
        meta: {
          name: 'Input',
        },
      },
      {
        path: '/template/dialog',
        component: () => import('@/mobile/page/template/Dialog'),
        meta: {
          name: 'Dialog',
        },
      },
    ],
    meta: {
      name: 'Template',
    },
  },
];

export default template;
